export default "__VITE_ASSET__DUyNYJYQ__"